import { FC } from "react";
import SmartSearchMonthYearAndActionsLayout from "../../../components/Layouts/smart-search-month-year-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetBingoCharityParams,
  getBingoCharityInvoice,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {SearchStatusEnum} from "../../../enums/searchStatusEnum";
import dayjs from "dayjs";

const BingoCharityInvoice: FC = () => {
  return (
    <SmartSearchMonthYearAndActionsLayout
      searchBy={[SearchOptionEnum.DISTRIBUTOR, SearchOptionEnum.CHARITY]}
      status={SearchStatusEnum.ACTIVE + "," + SearchStatusEnum.CLOSED}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      minYear={2014}
      validOnEmpty
      onRefresh={(output, month, year, params) => {
        const getBingoCharityInvoiceParams: GetBingoCharityParams = {
          output,
          fullMonth: dayjs()
            .set("date", 1)
            .set("month", Number(month))
            .set("year", Number(year))
            .format("YYYY-MM-DD"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getBingoCharityInvoiceParams[id as "distributorId" | "charityId"] =
            params.id;
        }

        return getBingoCharityInvoice(getBingoCharityInvoiceParams);
      }}
    />
  );
};

export default BingoCharityInvoice;
